'use client';

import Link from 'next/link';
import useStyles from './styles';

const footerLinks = [
  { label: 'Terms of Use', href: 'https://picsart.com/terms-of-use/', target: '_blank' },
  { label: 'Privacy Policy', href: 'https://picsart.com/privacy-policy/', target: '_blank' },
  { label: 'Internet-Based Advertising', href: 'https://picsart.com/privacy-policy/#interest-based', target: '_blank' },
  { label: 'Community Guidelines', href: 'https://picsart.com/community-guidelines/', target: '_blank' },
  { label: 'DMCA', href: 'https://picsart.com/copyright-dispute-policy/', target: '_blank' },
  { label: 'Security Policy', href: 'https://picsart.com/security-policy/', target: '_blank' },
  { label: 'Accessibility', href: 'https://picsart.com/accessibility-statement/', target: '_blank' },
];

// The cookie-settings layer of this site's DataGrail config (`showLayer` looks
// layers up by `banner_api_id`; an unknown id just reopens the default banner).
const PRIVACY_CHOICES_LAYER = 'categories-layer';

// Only if the banner script failed to load (blocked, or no script URL in this
// environment): the opt-out page is the same choice, without the banner.
const PRIVACY_OPT_OUT_URL = 'https://privacy.picsart.com/optout/';

// The California AG's official opt-out icon, unaltered, hosted on our CDN.
const PRIVACY_CHOICES_ICON_URL = 'https://pcdn.picsart.com/cms-uploads/e3e3d8c3-b996-4b32-95e3-7f291a28524b.svg';

const openPrivacyChoices = () => {
  if (window.DG_BANNER_API) window.DG_BANNER_API.showLayer(PRIVACY_CHOICES_LAYER);
  else window.open(PRIVACY_OPT_OUT_URL, '_blank', 'noopener,noreferrer');
};

const Footer = () => {
  const classes = useStyles();
  const currentYear = new Date().getFullYear();
  return (
    <footer data-pulse-section="footer" data-pulse-group="footer" className={classes.footer}>
      <div className={classes.inner}>
        <nav aria-label="Footer links">
          <ul className={classes.list}>
            {footerLinks.map(({ label, href, target }) => (
              <li key={label}>
                <Link target={target} rel="noopener noreferrer" className={classes.link} href={href} data-pulse-name={label}>
                  {label}
                </Link>
              </li>
            ))}
            {/*
              US state privacy laws (CCPA/CPRA and the states that followed) require
              this label with the California AG's official opt-out icon, unaltered
              (oag.ca.gov/privacy/ccpa/icons-download). Shown to everyone: it is
              compliant everywhere, and the site does not geo-target its footer.
            */}
            <li>
              <button type="button" className={classes.privacyChoices} onClick={openPrivacyChoices} data-pulse-name="Your Privacy Choices">
                Your Privacy Choices
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img src={PRIVACY_CHOICES_ICON_URL} width={30} height={14} alt="" aria-hidden className={classes.privacyChoicesIcon} />
              </button>
            </li>
          </ul>
        </nav>
        <p className={classes.copyright}>© {currentYear} PicsArt, Inc.</p>
      </div>
    </footer>
  );
};

export default Footer;
